import { render, staticRenderFns } from "./SlideWrapper.vue?vue&type=template&id=c1c5258a&"
import script from "./SlideWrapper.vue?vue&type=script&lang=js&"
export * from "./SlideWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports